// Core
import React from "react"
import styled from "styled-components"

// Style
import size from "../../../../../../styles/size"

// Assets
import OdGPixSVG from "../../../../../../assets/miscellaneous/odg-pix-2.svg"

const Container = styled.div`
  @media (max-width: ${size.laptop}) {
  }
`

const BankAccountsContainer = styled.div`
  padding: 5rem;
  border-radius: 15px;
  background-color: #ffffff;

  width: 350px;
  max-width: 100%;

  .title {
    font-weight: 600;
    font-size: 1.7rem;
  }

  .bank-name {
    margin-top: 25px;
    margin-bottom: 6px;
    text-transform: uppercase;
    font-weight: 600;
  }

  .pix-container {
    margin-top: 4rem;

    img {
      max-width: 100%;
    }
  }

  .cnpj {
    margin-top: 30px;
    font-weight: 600;
  }

  @media (max-width: ${size.laptop}) {
    margin-top: 5rem;
  }
`

export default function BankAccounts() {
  return (
    <Container>
      <BankAccountsContainer>
        <div className="title">Nossas Contas</div>

        <div className="cnpj">CNPJ: 05.122.594/0001-27</div>

        <div className="bank-name">Caixa Econômica Federal</div>
        <div>Ag: 4166 | Op: 003</div>
        <div>CC: 2296-8</div>

        <div className="bank-name">Banco do Brasil</div>
        <div>Ag: 1887-2</div>
        <div>CC: 55127-9</div>

        <div className="bank-name">BRB</div>
        <div>Ag: 083</div>
        <div>CC: 005.748-0</div>

        <div className="bank-name">BRADESCO</div>
        <div>Ag: 1409</div>
        <div>CC: 81288-9</div>

        <div className="bank-name">PIX</div>
        <div>CNPJ: 05122594000127</div>
        <div>TELEFONE: 61982302299</div>

        <div className="pix-container">
          <img src={OdGPixSVG} alt="05122594000127" />
        </div>
      </BankAccountsContainer>
    </Container>
  )
}
